export default __webpack_public_path__ + "static/media/Local Road - Active.cf9149e7.svg";